import { useImmerAtom } from 'jotai-immer';
import { useCallback } from 'react';
import { tblSpecSetFilter, tblSpecSetSort } from '../../../core/table/spec';
import { ListTableStateHookReturn, TblPagination, TblSortDir } from '../../../core/table/table.types';
import {
    splitInvoiceLineItemDispensesTableFiltersAtom,
    splitInvoiceLineItemDispensesTableStateAtom,
    splitInvoiceLineItemDispensesTableStatsAtom,
    splitInvoiceLineItemDispensesTableViewAtom,
} from './split_order_invoices_detail_atoms';

export const useSplitInvoiceLineItemDispensesTableState = (): ListTableStateHookReturn => {
    const [state, setState] = useImmerAtom(splitInvoiceLineItemDispensesTableStateAtom);
    const [view, setView] = useImmerAtom(splitInvoiceLineItemDispensesTableViewAtom);
    const [filters, setFilters] = useImmerAtom(splitInvoiceLineItemDispensesTableFiltersAtom);
    const [stats, setStats] = useImmerAtom(splitInvoiceLineItemDispensesTableStatsAtom);

    const setPaging = useCallback(
        (paging: Partial<TblPagination>): void => {
            setStats(draft => {
                if (paging.page !== undefined) {
                    draft.paging.page = paging.page;
                }
                if (paging.size !== undefined) {
                    draft.paging.size = paging.size;
                }
                if (paging.total !== undefined) {
                    draft.paging.total = paging.total;
                }
            });
        },
        [setStats],
    );

    const setSort = useCallback(
        (col: string, dir?: TblSortDir): void => {
            setView(draft => {
                draft.sort = tblSpecSetSort(col, view.cols, dir);
            });
        },
        [setView, view.cols],
    );

    const setFilter = useCallback(
        (key: string, val: any): void => {
            setFilters(draft => tblSpecSetFilter(draft, key, view.cols, val));
        },
        [setFilters, view.cols],
    );

    const setWait = useCallback(
        (waiting: boolean): void => {
            setState(draft => {
                draft.waiting = waiting;
            });
        },
        [setState],
    );

    return {
        waiting: state.waiting,
        views: state.views,
        currentViewId: state.currentViewId,
        cols: view.cols,
        sections: view.sections,
        sort: view.sort,
        filters,
        fltStats: stats.fltStats,
        paging: stats.paging,
        setWait,
        setSort,
        setFilter,
        setPaging,
    };
};
